import React, { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { updateUserProfile, clearError } from '../../store/slices/authSlice';

export default function ProfileModal({ onShowSavedBuilds, onSignOut, onSaveBuild, onChangePassword }) {
  const dispatch = useAppDispatch();
  const { user, isLoading, error } = useAppSelector((state) => state.auth);
  const [successMessage, setSuccessMessage] = useState('');
  const [formData, setFormData] = useState({
    email: '',
    firstName: '',
    lastName: '',
    phone: ''
  });

  useEffect(() => {
    // Load user data from Redux store (using camelCase to match GraphQL schema)
    if (user) {
      setFormData({
        email: user.email || '',
        firstName: user.firstName || '',
        lastName: user.lastName || '',
        phone: user.phoneNumber || ''
      });
    }
  }, [user]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleProfileSave = async (event) => {
    event.preventDefault();
    dispatch(clearError());
    setSuccessMessage('');

    try {
      const result = await dispatch(updateUserProfile({
        firstName: formData.firstName,
        lastName: formData.lastName,
        phone: formData.phone
      }));
      
      if (updateUserProfile.fulfilled.match(result)) {
        setSuccessMessage('Your profile has been updated successfully!');
        // Update the form data with the new values to keep inputs populated (using camelCase to match GraphQL schema)
        setFormData(prev => ({
          ...prev,
          firstName: result.payload.firstName,
          lastName: result.payload.lastName,
          phone: result.payload.phoneNumber
        }));
      }
    } catch (error) {
      // Error is handled by Redux
      console.error('Profile update error:', error);
    }
  };

  return (
    <>
      <div className="modal-header">
        <h2 className="modal-title">My Profile</h2>
      </div>
      <div className="modal-body saveBuildModalBody">
        <form className="profileForm" onSubmit={handleProfileSave}>
          <div className="profile-info">
            <div>
              <label htmlFor="email">Email:</label> <br />
              <input 
                className="input_100" 
                name="email" 
                type="email" 
                value={formData.email}
                readOnly 
                disabled={true}
              />
            </div>
            <div>
              <label htmlFor="firstName">First Name:</label> <br />
              <input 
                className="input_100" 
                name="firstName" 
                type="text" 
                value={formData.firstName}
                onChange={handleInputChange}
              />
            </div>
            <div>
              <label htmlFor="lastName">Last Name:</label> <br />
              <input 
                className="input_100" 
                name="lastName" 
                type="text" 
                value={formData.lastName}
                onChange={handleInputChange}
              />
            </div>
            <div>
              <label htmlFor="phone">Phone:</label> <br />
              <input 
                className="input_100" 
                name="phone" 
                type="tel" 
                value={formData.phone}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <button 
            type="submit" 
            className="orange-button button saveBuildButton"
            disabled={isLoading}
          >
            {isLoading ? 'Saving...' : 'Save Changes'}
          </button>
        </form>
        {error && <div className="error-message">{error}</div>}
        {successMessage && <div className="success-message">{successMessage}</div>}
        <div className="backToLogin">
          <a href="#" onClick={onShowSavedBuilds} className="link-button">Saved Builds</a>
        </div>
        {onChangePassword && (
          <div className="backToLogin">
            <a href="#" onClick={onChangePassword} className="link-button">Change Password</a>
          </div>
        )}
        <div className="backToLogin">
          <a href="#" onClick={onSignOut} className="link-button">Sign Out</a>
        </div>
      </div>
    </>
  );
}